<pg-expandable-form-card
  #expandableFormCard
  [originElement]="this.originElement"
>
  <div leftCol><ng-content select="pg-icon"></ng-content></div>
  <div rightCol><ng-content select="[pgCardRightCol]"></ng-content></div>

  <div previewCenterCol class="pg-card-title">
    <ng-content select="[pgCardPreviewTitle]"></ng-content>
  </div>
  <div expandedCenterCol class="pg-card-title">
    <ng-content select="[pgCardExpandedTitle]"></ng-content>
  </div>
  <div centerCol class="pg-card-subtitle">
    <ng-content select="[pgCardSubtitle]"></ng-content>
  </div>

  <div><ng-content select="[pgCardExpandedContent]"> </ng-content></div>
</pg-expandable-form-card>
